import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  authToken: null,
  id: null,
  name: "",
  email: "",
  user_type: 0,
  tenant: null,
  roles: [],
  permissions: [],
  default_location: null,
  error: null,
};

const authStart = (state) => {
  return updateObject(state, { error: null, loading: true });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    authToken: action.authToken,
    error: null,
    loading: false,
    name: action.name,
    email: action.email,
    id: action.id,
    user_type: action.user_type,
    tenant: action.tenant ?? null,
    roles: action.roles ?? [],
    permissions: action.permissions ?? [],
    default_location: action.default_location ?? null,
  });
};

const authFail = (state, action) => {
  if (action.error.data) {
    return updateObject(state, {
      error: {
        title: action.error.data.title,
        subtitle: action.error.data.subtitle,
      },
      loading: false,
    });
  }
  return updateObject(state, {
    error: {
      title: "",
      subtitle: "We could not complete your request, please try again.",
    },
    loading: false,
  });
};

const authLogout = () => {
  return initialState;
};

const updateAccount = (state, action) => {
  return updateObject(state, {
    name: action.name,
    email: action.email,
  });
};

const updateTenant = (state, action) => {
  return updateObject(state, {
    tenant: action.tenant,
  });
};

const updateDefaultLocation = (state, action) => {
  return updateObject(state, {
    default_location: action.default_location ?? null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state);
    case actionTypes.UPDATE_ACCOUNT_SUCCESS:
      return updateAccount(state, action);
    case actionTypes.UPDATE_TENANT_SUCCESS:
      return updateTenant(state, action);
    case actionTypes.UPDATE_DEFAULT_LOCATION_SUCCESS:
      return updateDefaultLocation(state, action);

    default:
      return state;
  }
};

export default reducer;
